const hrms = {
  employee: {
    list: '/hrms/employee',
    detail: id => `/hrms/employee/detail/${id}`,
    create: '/hrms/employee/new',
    update: id => `/hrms/employee/update/${id}`
  },
  separated_employee: {
    list: '/hrms/separated_employee',
    detail: id => `/hrms/separated_employee/detail/${id}`,
    update: id => `/hrms/separated_employee/update/${id}`
  },
  driver: {
    list: '/hrms/driver',
    detail: id => `/hrms/driver/detail/${id}`,
    create: '/hrms/driver/new',
    update: id => `/hrms/driver/update/${id}`
  },
  leave: '/hrms/leave',
  hr_report: '/hrms/hr_report',
  manualPunch: '/hrms/manualPunch',
  // attendance: {
  //   today_list: '/hrms/attendance/today',
  //   thisMonth_list: '/hrms/attendance/thisMonth'
  // },
  attendance: {
    driver: {
      today_list: '/hrms/attendance/driver/today',
      thisMonth_list: '/hrms/attendance/driver/thisMonth'
    },
    employee: {
      today_list: '/hrms/attendance/employee/today',
      thisMonth_list: '/hrms/attendance/employee/thisMonth'
    }
  },
  payroll: {
    driver: {
      payroll_run: '/hrms/payrolls/driver/run-payroll',
      payroll_history: '/hrms/payrolls/driver/payroll-history',

      create_payroll: '/hrms/payrolls/driver/create-payroll',
      check_payroll: '/hrms/payrolls/driver/check-payroll',
      pay_payroll: '/hrms/payrolls/driver/pay-payroll'
    },
    employee: {
      payroll_run: '/hrms/payrolls/employee/run-payroll',
      payroll_history: '/hrms/payrolls/employee/payroll-history',

      create_payroll: '/hrms/payrolls/employee/create-payroll',
      check_payroll: '/hrms/payrolls/employee/check-payroll',
      pay_payroll: '/hrms/payrolls/employee/pay-payroll'
    }
  }
};

export default hrms;
